import { Text } from "@ui-component-library";

const content = (props) => <div className="flex flex-col items-center max-w-[576px] mx-auto text-center ">
  <Text variant="text-sm/leading-normal/medium" className="text-[#737373] mb-4">
    {props.sectionName}
  </Text>

  <Text
    variant="text-3xl/leading-normal/medium"
    className="mb-6 max-w-[500px]"
    style={props.textColor ? { color: props.textColor } : undefined}
  >
    {props.title}
  </Text>
  <Text className="text-[#737373]" variant="text-base/leading-normal/normal">
    {props.text}
  </Text>
</div>

const HeroText = (props) => {
  if (props.variant === "embedded") return content(props);

  return (
    <div style={{ backgroundColor: props.backgroundColor || "#ffffff" }}>
      <section className="w-full py-12 container">
        {content(props)}
      </section>
    </div>
  );
};

HeroText.defaultProps = {
  backgroundColor: '',
  textColor: '',
  variant: "standalone",
  sectionName: "Bento grid section",
  title: "Feature-rich layout that captures attention",
  text: "Add a concise value statement that highlights your product's key features and benefits in a visually dynamic grid. Focus on creating balanced content blocks while keeping it under 2-3 lines. Align with your grid layout structure.",
};

HeroText.fields = {
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
  textColor: {
    type: "text",
    label: "Color HEX code for title",
  },
  backgroundColor: {
    type: "text",
    label: "Color HEX code for background",
  }
};

export default HeroText;
